export * from './status-detalhe-movimentacao.pipe';
